/**
 * tdesign v0.21.1
 * (c) 2022 tdesign
 * @license MIT
 */

import { _ as _defineProperty } from '../../_chunks/dep-0b4c3c44.mjs';
import { defineComponent, toRefs, ref, computed, nextTick, onMounted, watch, createVNode, mergeProps } from 'vue';
import { d as dayjs } from '../../_chunks/dep-f362c0f2.mjs';
import { c as customParseFormat } from '../../_chunks/dep-faa6c58f.mjs';
import { DEFAULT_FORMAT, DEFAULT_STEPS } from '../../_common/js/time-picker/const.mjs';
import { panelProps } from './props.mjs';
import SinglePanel from './single-panel.mjs';
import TButton from '../../button/button.mjs';
import { usePrefixClass } from '../../hooks/useConfig.mjs';
import { useConfig } from '../../config-provider/useConfig.mjs';
import '../../_chunks/dep-7071345f.mjs';
import '../../_chunks/dep-a48de419.mjs';
import '../props.mjs';
import '../../_chunks/dep-dcf624da.mjs';
import '../../_chunks/dep-556a2f2c.mjs';
import '../../_chunks/dep-241fdd8c.mjs';
import '../../_chunks/dep-d2403b2f.mjs';
import '../../_chunks/dep-0b4185fe.mjs';
import '../../_chunks/dep-3ca5fb38.mjs';
import '../../_chunks/dep-050b3eb2.mjs';
import '../../_chunks/dep-977c5cdd.mjs';
import '../../_chunks/dep-c27b1c14.mjs';
import '../../_chunks/dep-361522ee.mjs';
import '../../_chunks/dep-169ea640.mjs';
import '../../_chunks/dep-469bf54b.mjs';
import '../../_chunks/dep-7922050a.mjs';
import '../../_chunks/dep-59545a4d.mjs';
import '../../_chunks/dep-8e38f523.mjs';
import '../../_chunks/dep-3568c22b.mjs';
import '../../_chunks/dep-a82b01df.mjs';
import '../../_chunks/dep-192e10f1.mjs';
import '../../_chunks/dep-3d4aad09.mjs';
import '../../_chunks/dep-82798823.mjs';
import '../../_chunks/dep-52cbb58a.mjs';
import '../../_chunks/dep-a25f46ac.mjs';
import '../../_common/js/time-picker/utils.mjs';
import '../../_chunks/dep-8c39d78a.mjs';
import '../../loading/index.mjs';
import '../../loading/directive.mjs';
import '../../loading/plugin.mjs';
import '../../loading/loading.mjs';
import '../../loading/icon/gradient.mjs';
import '../../_common/js/loading/circle-adapter.mjs';
import '../../_common/js/utils/set-style.mjs';
import '../../_common/js/utils/helper.mjs';
import '../../_chunks/dep-e68fd68c.mjs';
import '../../utils/dom.mjs';
import '../../_chunks/dep-2684fd15.mjs';
import '../../utils/easing.mjs';
import '../../utils/render-tnode.mjs';
import '../../_chunks/dep-40522c7c.mjs';
import '../../_chunks/dep-83862ee1.mjs';
import '../../_chunks/dep-f6b25712.mjs';
import '../../_chunks/dep-7d96367f.mjs';
import '../../_chunks/dep-4889eb51.mjs';
import '../../_chunks/dep-caad2e91.mjs';
import '../../_chunks/dep-8e451077.mjs';
import '../../_chunks/dep-755716aa.mjs';
import '../../_chunks/dep-db11154e.mjs';
import '../../_chunks/dep-baa4f9dc.mjs';
import '../../utils/transfer-dom.mjs';
import '../../loading/props.mjs';
import '../../_chunks/dep-bfb23a5e.mjs';
import '../../_chunks/dep-2a7dc5c7.mjs';
import '../../_chunks/dep-9311bf66.mjs';
import '../../_chunks/dep-827c4600.mjs';
import '../../_chunks/dep-0820e0e2.mjs';
import '../../_chunks/dep-8ef9fb8e.mjs';
import '../../_chunks/dep-e769aafd.mjs';
import '../../_chunks/dep-400798c5.mjs';
import '../../_common/js/global-config/default-config.mjs';
import '../../_common/js/global-config/locale/zh_CN.mjs';
import '../../config-provider/type.mjs';
import '../../utils/withInstall.mjs';
import './style/css.mjs';
import '../../loading/type.mjs';
import '../../button/props.mjs';
import '../../hooks/useRipple.mjs';
import '../../hooks/useKeepAnimation.mjs';
import '../../utils/set-style.mjs';
import '../../form/hooks.mjs';
import '../../hooks/tnode.mjs';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
dayjs.extend(customParseFormat);
var _TimePickerPanel = defineComponent({
  name: "TimePickerPanel",
  props: _objectSpread(_objectSpread({}, panelProps()), {}, {
    isFooterDisplay: Boolean,
    handleConfirmClick: Function,
    onChange: Function
  }),
  setup: function setup(props) {
    var panelClassName = usePrefixClass("time-picker__panel");

    var _toRefs = toRefs(props),
        steps = _toRefs.steps,
        isFooterDisplay = _toRefs.isFooterDisplay,
        isShowPanel = _toRefs.isShowPanel;

    var triggerScroll = ref(false);
    var panelRef = ref();

    var _useConfig = useConfig("timePicker"),
        globalConfig = _useConfig.globalConfig;

    var showNowTimeBtn = computed(function () {
      return !!steps.value.filter(function (v) {
        return v > 1;
      }).length;
    });
    var defaultValue = computed(function () {
      var isStepsSet = showNowTimeBtn.value;

      if (props.value) {
        return dayjs(props.value, props.format);
      }

      if (isStepsSet) {
        return dayjs().hour(0).minute(0).second(0);
      }

      return dayjs();
    });

    var panelColUpdate = function panelColUpdate() {
      nextTick(function () {
        triggerScroll.value = true;
      });
    };

    var resetTriggerScroll = function resetTriggerScroll() {
      triggerScroll.value = false;
    };

    onMounted(function () {
      panelColUpdate();
    });
    watch(function () {
      return isShowPanel.value;
    }, function () {
      panelColUpdate();
    });
    return function () {
      return createVNode("div", {
        "class": panelClassName.value
      }, [createVNode("div", {
        "class": "".concat(panelClassName.value, "-section-body")
      }, [createVNode(SinglePanel, mergeProps(props, {
        "ref": panelRef,
        "format": props.format || DEFAULT_FORMAT,
        "steps": props.steps || DEFAULT_STEPS,
        "value": props.value,
        "triggerScroll": triggerScroll.value,
        "onChange": props.onChange,
        "resetTriggerScroll": resetTriggerScroll
      }), null)]), isFooterDisplay.value ? createVNode("div", {
        "class": "".concat(panelClassName.value, "-section-footer")
      }, [createVNode(TButton, {
        "theme": "primary",
        "variant": "base",
        "onClick": function onClick() {
          return props.handleConfirmClick(defaultValue.value);
        },
        "size": "small"
      }, {
        "default": function _default() {
          return [globalConfig.value.confirm];
        }
      }), !showNowTimeBtn.value ? createVNode(TButton, {
        "theme": "primary",
        "variant": "text",
        "size": "small",
        "onClick": function onClick() {
          return props.onChange(dayjs().format(props.format));
        }
      }, {
        "default": function _default() {
          return [globalConfig.value.now];
        }
      }) : null]) : null]);
    };
  }
});

export { _TimePickerPanel as default };
//# sourceMappingURL=time-picker-panel.mjs.map
